import { Component, HostListener, OnInit, OnDestroy, Inject } from '@angular/core';
import { ApplicationState, getApplicationState, GetLayers, UpdateWindowSize } from './state-management';
import { Observable, Subject } from 'rxjs';
import { takeUntil, filter } from 'rxjs/operators';
import { ConfigService } from './services/config.service';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
// import { Subject } from 'rxjs';
// import { filter, takeUntil } from 'rxjs/operators';
// import {
//   MsalService, // BroadcastService
// } from './msal';
import { EventType, InteractionType, PopupRequest, RedirectRequest } from '@azure/msal-browser';
import {
  MsalService, MsalBroadcastService, MsalGuardConfiguration,
  MSAL_GUARD_CONFIG
} from '@azure/msal-angular';
// import { MSAL_GUARD_CONFIG, InteractionType, EventType } from './msal/constants';
// import { MsalGuardConfiguration } from './msal/msal.guard.config';

import { State, DelayedAction } from './state-management';
import { AuthConfig } from './state-management/auth';
// import * as fromEnvironment from '../environments/environment';
// import { environment } from 'src/environments/environment';
import { SetIcons, SetMapState, SetSearchItemsUrl, DrawUndo } from 'dnv-lib';

// Import honeybadger.js
// import * as Honeybadger from "@honeybadger-io/js";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'GeoTools';
  isIframe = false;
  loggedIn = false;
  private readonly destroying$ = new Subject<void>();

  // environment = environment.environment;
  //environment = environment;
  environment = '';
  private ngUnsubscribe: Subject<void> = new Subject();

  application$: Observable<ApplicationState>;
  // access: boolean;

  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private authService: MsalService,
    private broadcastService: MsalBroadcastService,
    // private broadcastService: BroadcastService,
    // private authService: MsalService,
    private configService: ConfigService,
    private store: Store<{}>,
    private router: Router
  ) {
    this.application$ = this.store.select(getApplicationState);

  }

  ngOnInit(): void {
    this.isIframe = window !== window.parent && !window.opener;

    // this line casues msal uninitialized error and RAP doesn't do this
    /* this.checkAccount();*/
    // Honeybadger.notify("Testing Honeybadger!");

    this.broadcastService.msalSubject$
      .pipe(
        filter(msg => msg.eventType === EventType.LOGIN_SUCCESS || msg.eventType === EventType.ACQUIRE_TOKEN_SUCCESS),
        takeUntil(this.destroying$)
      )
      .subscribe((result) => {
        this.checkAccount();
      });
    this.application$
      .pipe(
        takeUntil(this.ngUnsubscribe),
      )
      .subscribe(appState => {
        if (appState.appSettings) {
          this.environment = appState.appSettings['environment.environment'];
        }
      });
  }

  checkAccount(): void {
    this.loggedIn = this.authService.instance.getAllAccounts().length > 0;
  }

  login(): void {
    if (this.msalGuardConfig.interactionType === InteractionType.Popup) {
      this.authService.loginPopup({ ...this.msalGuardConfig.authRequest } as PopupRequest)
        .subscribe(() => this.checkAccount());
    } else {
      this.authService.loginRedirect({ ...this.msalGuardConfig.authRequest } as RedirectRequest);
    }
  }

  // logout() {
  //   this.authService.logout();
  // }

  ngOnDestroy(): void {
    this.destroying$.next(null);
    this.destroying$.complete();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any): void {
    this.store.dispatch(new UpdateWindowSize({
      windowInnerHeight: event.target.innerHeight,
      windowInnerWidth: event.target.innerWidth
    }));
  }

  // Feature undo
  @HostListener('window:keyup.control.z', ['$event'])
  onUndo(event: any): void {
    this.store.dispatch(new DrawUndo());
  }
}
